import Common from '../../Common';
import { UserSmsBrowse } from '../user/SMS';
export interface CompanySmsBrowse {
	id: id
	added: string
	sender: null | string
	confirmed: string
	pbx_user_id: id
}

export type CompanySms = UserSmsBrowse

const SMS = class extends Common {
	browse = (search: any = {}): CustomResponseBrowse<{ sms: CompanySmsBrowse[]}> =>
		this.get(`/company/sms`, search)

	read = (smsId: id): CustomResponse<CompanySms> =>
		this.get(`/company/sms/${smsId}`)
}

export default SMS;
